import { createUploadLink } from "apollo-upload-client";
import { config } from "../config";

export const uploadLink = createUploadLink({
  uri: config.serverUrl,
  credentials: "same-origin",
});
